import classNames from "classnames/bind";
import styles from "./ConfigObject.module.css";
import { useEffect, useState } from "react";
import { getCommonObject } from "../../../../../services/api/aiConfigService";
import { Button, Col, Loading, Row, Toast } from "../../../../../components";
import { ObjectLisencePlate } from "../../../Camera/Setting/source";

const cx = classNames.bind(styles);

function ConfigObject({ nameService }) {
    const [listObject, setListObject] = useState([]);
    const [seeAll, setSeeAll] = useState(false);
    const [dataMap, setDataMap] = useState([
        { CODE: 1, CODE_SYSTEM: 'person', NAME_VN: 'Người', PRIORITY: 1, STATUS: true },
        { CODE: 3, CODE_SYSTEM: 'car', NAME_VN: 'Xe hơi', PRIORITY: 1, STATUS: true },
        { CODE: 8, CODE_SYSTEM: 'truck', NAME_VN: 'Xe tải', PRIORITY: 1, STATUS: true },
    ]);
    const [loading, setLoading] = useState(true);
    // 3 vật thể mặc định
    const onChangeStatus = (code, check) => {
        const data = listObject.map(item => {
            if (item.CODE === code) {
                return {
                    ...item,
                    STATUS: check,
                }
            } else {
                return item
            }
        })
        setListObject(data)
        if (seeAll) {
            setDataMap(data)
        } else {
            const firstData = data.slice(0, 9);
            setDataMap(firstData)
        }
    }


    const getListCommonObject = async () => {
        try {
            const res = getCommonObject.getList()
            return res;
        } catch (error) {
            Toast.open('Không thể lấy danh sách vật thể', 'danger')
            return null;
        }
    }

    const handelChangeView = () => {
        setSeeAll(!seeAll)
        if (seeAll) {
            let firstData = listObject.slice(0, 10);
            setDataMap(firstData);
        } else {
            setDataMap(listObject)
        }
    }

    useEffect(() => {
        const getData = async () => {
            let listData = [];
            if (nameService.toLowerCase() === 'nhận dạng biển số xe') {
                listData = ObjectLisencePlate;
            } else {
                listData = await getListCommonObject();
            }
            const listActive = [];
            if (listData && listActive) {
                const dataDefault = listData?.data.map(item => {
                    let index;
                    if (nameService.toLowerCase() === 'nhận dạng biển số xe') {
                        index = listActive?.data?.findIndex(item1 => item.CODE === item1.ALPR_OBJECT_CODE);
                    } else {
                        index = listActive?.data?.findIndex(item1 => item.CODE === item1.COMMON_OBJECT_CODE);
                    }
                    if (index >= 0) {
                        return {
                            ...item,
                            STATUS: true,
                        }
                    } else {
                        if (item)
                            return {
                                ...item,
                                STATUS: false
                            }
                    }
                })
                setListObject(dataDefault)
                let firstData = dataDefault.slice(0, 9);
                setDataMap(firstData)
                setLoading(false)
            }
        }
        getData()
    }, [nameService])

    const handleCancel = () => {

    }

    const handleApplyAll = () => {

    }

    const handleAppForNewCam = () => {

    }


    return (
        <>
            {loading && <div className={cx('modal-load')}>
                <Loading />
            </div>}
            <Row gap={[0, 16]}>
                <Col span={6}>
                    <div className={cx('wrapper')}>
                        <div className={cx('list-item')}>
                            {dataMap.length > 0 && dataMap?.map((item) => {
                                return (
                                    <div className={cx('item')} key={item.CODE}>
                                        <input
                                            className={cx('input-name')}
                                            name={'check-common'}
                                            checked={item.STATUS}
                                            type="checkbox"
                                            onChange={(e) => onChangeStatus(item.CODE, e.target.checked)}
                                        />
                                        <label
                                            className={cx('label')}
                                            htmlFor={'check-common'}
                                            onClick={() => onChangeStatus(item.CODE, item.STATUS)}
                                        >
                                            {item.NAME_VN}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className={cx('show-more-btn')}
                            onClick={handelChangeView}
                        >{seeAll ? 'Xem một phần' : 'Xem tất cả'}</div>
                        <Row gap={[0, 16]}>
                            <Col span={12}>
                                <div className={cx('footer')}>
                                    <Button title={'Hủy'} className={cx('btn', 'cancel')} onClick={handleCancel} />
                                    <Button title={'Lưu và áp dụng cho tất cả các cam'} className={cx('btn')} onClick={handleApplyAll} />
                                    <Button title={'Lưu và áp dụng cho các cam mới'} className={cx('btn')} onClick={handleAppForNewCam} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default ConfigObject;